import jwtDecode from 'jwt-decode';

// Types d'actions
const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const UPDATE_PROFILE = 'UPDATE_PROFILE';
const SET_SUSPENDU = 'UPDATE_SUSPENDU';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const CHECK_TOKEN_VALIDITY = 'CHECK_TOKEN_VALIDITY';

// Créateurs d'actions
export const setSuspendu = (status) => ({
  type: SET_SUSPENDU,
  payload: { suspendre: status === "suspendu" },
});

export const checkTokenValidity = () => ({
  type: CHECK_TOKEN_VALIDITY,
});

export const loginAction = (user, token, refreshToken) => ({
  type: LOGIN,
  payload: { user, token, refreshToken },
});

export const logoutAction = () => ({
  type: LOGOUT,
  payload: null,
});

export const updateProfile = (user) => ({
  type: UPDATE_PROFILE,
  payload: { user },
});

export const refreshTokenAction = (token, refreshToken) => ({
  type: REFRESH_TOKEN,
  payload: { token, refreshToken },
});

// État initial
const initialState = {
  isAuthenticated: false,
  token: null,
  refreshToken: null,
  user: null,
  isTokenValidated: false,
};

// Reducer
export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        isTokenValidated: true,
        user: payload.user,
        token: payload.token,
        refreshToken: payload.refreshToken,
      };

    case UPDATE_PROFILE:
      return {
        ...state,
        user: { ...state.user, ...payload.user },
      };

    case SET_SUSPENDU:
      return {
        ...state,
        user: { ...state.user, statusSuspendre: payload.suspendre },
      };

    case CHECK_TOKEN_VALIDITY:
      try {
        if (state.token) {
          const decoded = jwtDecode(state.token);
          const isExpired = decoded.exp < Date.now() / 1000;
          return {
            ...state,
            isTokenValidated: true,
            isAuthenticated: !isExpired,
          };
        }
        return { ...state, isTokenValidated: true, isAuthenticated: false };
      } catch (error) {
        return { ...state, isTokenValidated: true, isAuthenticated: false };
      }

    case REFRESH_TOKEN:
      return {
        ...state,
        token: payload.token,
        refreshToken: payload.refreshToken || state.refreshToken,
        isTokenValidated: true,
      };

    case LOGOUT:
      return { ...initialState, isTokenValidated: true };

    default:
      return state;
  }
};